<template >
  <v-flex xs12 sm12 md12 lg12 xl12>
  <!--<div id="contentread mx-4" >-->
    <Navbar></Navbar>
    <v-container class="" >
      <h1 class="pl-0 ml-3 pt-5 hidden-xs-only" style="color:#942C75; font-family:Poppins; font-size:1.8vw; font-weight:500">MANUALES</h1>
      <h1 class="pl-1 ml-4 pt-5 hidden-sm-and-up" style="color:#942C75; font-family:Poppins; font-size:3vw; font-weight:500">MANUALES</h1>

      <v-layout row wrap justify-center>
        <v-flex xs12 sm6 md6 lg6 xl5 v-for="file in files" :key="file.title">
          <v-card flat class="pa-3" style="background-color:#D6D6D6">        
            <v-img :src="file.img" width="100%">
              <v-layout align-center justify-center fill-height class="center" >
                <v-card-actions >
                <!--<div class="center">-->
                  <a :href="file.url" style="text-decoration:none" target="_blank" >
                    <v-btn slot="badge" flat color="#8A2663" style="font-family:Poppins;" >
                      <span>{{file.title}}</span>
                    </v-btn>
                  </a>         
                </v-card-actions>
              </v-layout>

              <div class="downloadfile">
                <v-card-actions >
                  <a @click="downloadItem(file.url,file.namedownload)">
                    <img src="descargar.png" class="download hidden-sm-and-down">
                    <img src="descargar.png" class="download hidden-md-and-up" width="50px" >
                  </a>
                </v-card-actions>
              </div>
            </v-img>      
          </v-card>

        </v-flex>
      </v-layout>

    </v-container>
  </v-flex>
</template>

<script type="text/javascript">
  import Navbar from "@/components/Navbar.vue"
  import axios from 'axios'

  export default {
      components:{
          Navbar
      },
      
      props:['files'],

     methods:{

        downloadItem (url,name) {
        axios.get(url, { responseType: 'blob' })
          .then(({ data }) => {
            const blob = new Blob([data], { type: 'application/pdf' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = name
            link.click()
          }).catch(error => console.error(error))
        }
        
}
     }
</script>




<style scoped>

@media (min-width: 700px){
.center span{
  font-size:1.5vw;  
}
}

@media (min-width: 300px) and (max-width: 700px){
.center span{
  font-size:4.2vw;  
}

}

.downloadfile{
  position: absolute; bottom: -15px; right: -10px;
}

.download:hover {
  transform: scale(1.1); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

</style>
